import React from 'react'

const FooterCopyRight = () => {
  return (
    <p className='py-6 text-center font-["Inter"] cursor-pointer text-xs sm:text-base 2xl:text-[20px] text-[#C0C0C0] hover:text-white transition ease-in-out duration-500 '>
      © 2023 - Pixelquest
    </p>
  )
}

export default FooterCopyRight